/**
 * Created by tong on 2018/2/3.
 */
import {config, request, objectSerial} from 'Utils';
/*客户列表页接口*/

/*客户列表接口*/
export function list(param) {
    return request(`${config.server}/api/v1/dms/employee/list`, {
        method: 'post',
        body: {...param},
    });
}

export function sync() {
    return request(`${config.server}/api/v1/dms/syncCustomer/cus`);
}

/*客户类型筛选接口*/
export function customerScreening(param) {
    return request(`${config.server}/api/v1/dms/dictionay/selectChild/EPM_ORG${objectSerial(param)}`);
}

/*片区筛选接口*/
export function areaScreening() {
    return request(`${config.server}/api/v1/dms/treeRelation/tgTree`);
}

/*客户详情页接口*/

/*客户详情接口*/
export function detail(param) {
    return request(`${config.server}/api/v1/dms/employee/detail?id=${param}`);
}

/*客户详情页接口*/

/*客户详情接口*/
export function linkMandetail(param) {
    return request(`${config.server}/api/v1/dms/employee/detailEmp?id=${param}`);
}

/*订单统计列表接口*/
export function getOrderList(param) {
    return request(`${config.server}/api/v1/dms/employee/order/${param}`);
}

/*子账户列表接口*/
export function getLinkmanList(param) {
    return request(`${config.server}/api/v1/dms/employee/childs`, {
        method: 'post',
        body: param,
    });
}

/*二级客户详情--子账号--列表*/
export function getSecondChilds(param) {
    return request(`${config.server}/api/v1/dms/employee/secondChilds`, {
        method: 'post',
        body: param,
    });
}

/*子账户列表接口*/
export function getSecondChildAccount(param) {
    return request(`${config.server}/api/v1/dms/employee/getSecondChildAccount`, {
        method: 'post',
        body: param,
    });
}

/*购货单位列表接口*/
export function getStoreList(param) {
    return request(`${config.server}/api/v1/dms/employee/purchase`, {
        method: 'post',
        body: param,
    });
}

/*收货地址列表接口*/
export function getGoodsList(param) {
    return request(`${config.server}/api/v1/dms/employee/address`, {
        method: 'post',
        body: {...param},
    });
}

/*二级客户详情-收货地址-新增或修改*/
export function saveOrUpdateSecondaAdress(param) {
    return request(`${config.server}/api/v1/dms/employee/secondaAdress/saveOrUpdate`, {
        method: 'post',
        body: {...param},
    });
}

/*二级客户详情-审核*/
export function secondCustomerAudit(param) {
    return request(`${config.server}/api/v1/dms/employee/secondCustomerAudit`, {
        method: 'post',
        body: {...param},
    });
}

/*二级客户详情--收货地址--删除*/
export function deleteAddress(addressId) {
    return request(`${config.server}/api/v1/dms/employee/address/delete/${addressId}`);
}

/*信用情况接口*/
export function getCreditList(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/gdCredit`, {
        method: 'post',
        body: param,
    });
}

/*信用情况接口*/
export function getZhiXiaoList(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/zyPurchase`, {
        method: 'post',
        body: param,
    });
}

/*二级客户订单列表接口*/
export function getLinkmanList2(param) {
    return request(`${config.server}/api/v1/dms/trans/order/list/${param}`);
}

/*二级客户子账户开通账号*/
export function createAccount(param) {
    return request(`${config.server}/api/v1/dms/employee/update`, {
        method: 'post',
        body: {...param},
    });
}

/**
 * 自定义快捷方式 插件的左边数据
 * @param param
 * @returns {*}
 */
export function channelLeftCustomerSideList(param) {
    //http://192.168.31.46:8180/xweb/api/v1/dms/homePage/channel
    return request(`${config.server}/api/v1/dms/dmsTgChannel/selectCusChannel${objectSerial(param)}`, {
        method: 'get'

    });
}

/**
 * 渠道弹出框 右边客户当前的列表
 * @param param
 * @returns {*}
 */
export function fetchCustomRightChannelList(param) {
    return request(`${config.server}/api/v1/dms/dmsTgChannel/searchByCus?${objectSerial(param)}`, {
        method: 'get'
    });
}

export function fetchCustomRightBusinessList(param) {
    return request(`${config.server}/api/v1/dms/dmsTgChannel/searchBusinessLineByCus?${objectSerial(param)}`, {
        method: 'get'
    });
}

export function updateAddress(param) {
    return request(`${config.server}/api/v1/dms/employee/address/update`, {
        method: 'post',
        body: param,
    });
}



// WEBPACK FOOTER //
// ./src/service/customerManagement/index.js